import React from 'react';
import {Link} from "react-router-dom";
import moment from "moment";
import "moment/locale/pl";
import ReactHtmlParser from "react-html-parser";
import goAutoLogo from "../../assets/images/content/logos/goauto_logo.svg";

function BlogArticleCard({post}) {

    const formattedDate = post.creationDate ? moment(post.creationDate).locale('pl').format('D MMMM YYYY') : '';
    const badges = (post.tagNames || []).map(tag => tag.trim()).filter(Boolean).slice(0, 2);

    return (
        <Link to={`/blog/post/${post.link}`} className="blog2-card">
            <div className="blog2-card-photo">
                <img src={post.backgroundUrl ? post.backgroundUrl : goAutoLogo} alt=""/>
                <div className="blog2-card-photo-overlay"/>
                {badges.length > 0 && (
                    <div className="blog2-card-badges">
                        {badges.map(badge => (
                            <span className="blog2-card-badge" key={badge}>{badge}</span>
                        ))}
                    </div>
                )}
            </div>
            <div className="blog2-card-body">
                {formattedDate && <p className="blog2-card-date">{formattedDate}</p>}
                <p className="blog2-card-title">{ReactHtmlParser(post.title)}</p>
            </div>
        </Link>
    );
}

export default BlogArticleCard;
